import styled, { css } from "styled-components";

interface CardInfoInterface {
  color?: string;
}

interface StyledComponentProps {
  hospital: string;
}

const getBorderColor = (item: StyledComponentProps["hospital"]): string => {
  switch (item) {
    case "HRBz":
    case "HRC":
    case "HRSam":
    case "HSVP":
    case "HRT":
      return "#527d9b";
    case "HRPL":
    case "HRS":
    case "HRL":
      return "#af6c9c";
    case "HRGu":
    case "HRG":
    case "HMIB":
    case "HRAN":
    default:
      return "#ff80cc";
  }
};

export const ContainerHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2rem;
  h3 {
    margin: 0;
  }
`;

export const ContainerCard = styled.div`
  border: 1px solid #cecece;
  height: 300px;
  width: 300px;
  background-color: #fff;
  border-radius: 8px;
`;

export const Full = styled.div`
  height: 80%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: relative;

  h3 {
    color: ${(props) => props.theme.colors.black};
    margin: -5px 0 5px 0 !important;
  }

  div:nth-child(2) {
    position: absolute;
    right: 0;
    top: -6px;
  }

  svg {
    font-size: 1.5rem;
    color: red;
  }

  @media (max-width: 700px) {
    div:nth-child(2) {
      top: -7px;
    }
  }
`;

export const CardContainer = styled.div`
  width: 100%;
  padding-top: 16px;
  h3 {
    margin: 0;
    padding: 0;
  }
`;

const commonCardStyles = css<StyledComponentProps>`
  background: #fff;
  border: 6px solid ${(props) => getBorderColor(props.hospital)};
  border-radius: 8px;
  padding: 13px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const Card = styled.div<StyledComponentProps>`
  ${commonCardStyles}
  display: inline-block;
  float: left;
  width: calc(33% - 16px);
  margin: 0 0 16px 16px;
`;

export const BigCard = styled.div<StyledComponentProps>`
  ${commonCardStyles}
`;

export const ChipsCard = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  border-radius: 8px;
  background-color: #d9d9d9;
  min-height: auto;
  width: 100%;
  padding: 10px;
  gap: 3px;

  p {
    margin: 0;
    padding: 0;
  }

  span {
    font-weight: bold;
    font-size: 16px;
  }
`;

export const DivInfoMedia = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-size: 9px;
  }
`;

export const CardInfo = styled.div<CardInfoInterface>`
  border: 3px solid ${(props) => (props.color ? props.color : "#3366FF")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  border-radius: 10px;
  gap: 10px;

  svg {
    /* color: #fff; */
    color: ${(props) => (props.color ? props.color : "#3366FF")};
    /* font-size: 30px; */
  }

  span {
    font-weight: bold;
    font-size: 14px;
    color: ${(props) => props.theme.colors.black};
  }

  div:nth-child(2) {
    span {
      font-size: 14px;
    }
  }
`;

export const PLineHeigth2 = styled.div`
  line-height: 1;
  font-weight: 400;
  color: #8b8000;
  font-size: 12px;
`;
